<div class="db-recreate-website__steps fromDialog"  *ngIf="fromDialog" >
  <h1 *ngIf="title">{{title}}</h1>
  <p *ngIf="description">{{description}}</p>

  <div [ngClass]="{'db-step1': tabIndex == 1, 'db-step2': tabIndex == 2, 'db-step3': tabIndex == 3}" (touchmove)="handleTouchMove($event)" (touchstart)="handleTouchStart($event)">
    <div class="db-recreate-website__step" [ngClass]="{'active': tabIndex == 1}">
      <img src="assets/images/illustrations/recreate.png" alt=""/>
      <h1>Step 1</h1>
      <p [innerHTML]="'text_aiBuilder__step1' | dbText"></p>
    </div>

    <div class="db-recreate-website__step" [ngClass]="{'active': tabIndex == 2}">
      <div>
        <div class="db-recreate-website-steps__middle"></div>
        <img src="assets/images/illustrations/ai_scraping.png" alt=""/>
        <div class="db-recreate-website-steps__middle"></div>
      </div>
      <h1>Step 2</h1>
      <p [innerHTML]="'text_aiBuilder__step2' | dbText"></p>
    </div>

    <div class="db-recreate-website__step" [ngClass]="{'active': tabIndex == 3}">
      <img src="assets/images/illustrations/automate_template_creation.png" alt=""/>
      <h1>Step 3</h1>
      <p [innerHTML]="'text_aiBuilder__step3' | dbText"></p>
    </div>
  </div>
  <div class="db-steps-circle" >
    <span (click)="tabIndex = 1" [ngClass]="{'active': tabIndex == 1}"></span>
    <span (click)="tabIndex = 2" [ngClass]="{'active': tabIndex == 2}"></span>
    <span (click)="tabIndex = 3" [ngClass]="{'active': tabIndex == 3}"></span>
  </div>
  <a class="db-button db-button_lg db-button_info " *ngIf="fromDialog"  [ngClass]="{'db-button__from-dialog': fromDialog}" [routerLink]="['/websites/' + websiteId + '/builder/recreate-website']">
    <span *ngIf="!loading">{{'text_aiBuilder__stepGetStarted' | dbText}}</span>
    <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
  </a>
</div>
<div class="builder-trial-empty-page" *ngIf="!fromDialog">
  <div class="db-recreate-website__steps">
    <h1 class="trial__title" [innerHTML]="'text_ai-builder-trial__title' | dbText"></h1>
    <p class="trial__desc"> {{'text_ai-builder-trial__desc' | dbText}}</p>
    <div class="db-recreate-website__step">
      <div class="trial__step">
        <i  class="db-icon db-icon-checkbox-round"></i>
        <p >{{'text_ai-builder-trial__step1' | dbText}}</p>
      </div>
      <div class="trial__step">
        <i  class="db-icon db-icon-checkbox-round"></i>
        <p >{{'text_ai-builder-trial__step2' | dbText}}</p>
      </div>
      <div class="trial__step">
        <i  class="db-icon db-icon-checkbox-round"></i>
        <p >{{'text_ai-builder-trial__step3' | dbText}}</p>
      </div>
    </div>
    <a class="db-button db-button_lg db-button_info trial" [routerLink]="['/websites/' + websiteId + '/builder-trial']">
      <span *ngIf="!loading">{{'text_aiBuilder__stepGetStarted' | dbText}}</span>
      <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
    </a>
  </div>

</div>
